import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const getCookies = ({ name }) => cookies.get(name);
export const setCookies = ({ name, value, options = {} }) => cookies.set(name, value, options);
export const removeCookies = ({ name }) => {
  // Remove cookie with multiple approaches to ensure it's gone
  cookies.remove(name);
  cookies.remove(name, { path: '/' });
  
  // Direct manipulation for maximum compatibility
  if (typeof document !== 'undefined') {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;`;
    
    // Also try with domain
    const domain = window.location.hostname;
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${domain};`;
  }
};

// Function to trigger logout across all tabs using localStorage
export const logoutAllTabs = () => {
  if (typeof window !== 'undefined') {
    try {
     
    } catch (e) {
      console.error('Error in logoutAllTabs:', e);
    }
  }
};

// Function to check if logout was triggered in another tab
export const checkGlobalLogout = () => {
  if (typeof window !== 'undefined') {
    try {
      
    } catch (e) {
      console.error('Error in checkGlobalLogout:', e);
      return null;
    }
  }
  return null;
};

// Clear all browser cookies
const removeAllBrowserCookies = () => {
  try {
    // First use the library method
    removeCookies({ name: 'id_token' });
    
    // Then try a more aggressive approach with document.cookie
    if (typeof document !== 'undefined') {
      const cookies = document.cookie.split(";");
      
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();
        
        // Clear all auth-related cookies
        if (name.includes('token') || name.includes('auth') || name.includes('admin') || name === 'id_token') {
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;";
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=" + window.location.hostname;
        }
      }
    }
  } catch (e) {
    console.error('Error clearing cookies:', e);
  }
};

// Clear all relevant localStorage items
const clearLocalStorage = () => {
  try {
    // Collect all keys to remove first
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      // Skip the logout indicator keys
      if (key && key !== 'admin_global_logout' && key !== 'admin_logout_id') {
        if (key.includes('admin') || key.includes('token') || key.includes('auth') || 
            key.includes('redux') || key.includes('session')) {
          keysToRemove.push(key);
        }
      }
    }
    
    // Remove collected keys
    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
    });
    
    // Also clear sessionStorage except for the redirect flag
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key && key !== 'admin_redirecting_to_login') {
        sessionStorage.removeItem(key);
      }
    }
  } catch (e) {
    console.error('Error clearing storage:', e);
  }
};

